import React from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import InsuranceMembershipIdQuestionRHF from './insurance-membership-id-question-rhf'
import InsuranceMembershipIdQuestionZustand from './insurance-membership-id-question-zustand'

interface InsuranceMembershipIdQuestionProps {
  question: {
    id: number | string
    text: string
    isRequired?: boolean
    type: string
    placeholder?: string
    responses?: Array<{
      id: number | string
      text: string
    }>
  }
  // RHF mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: string | null
  skipValue?: boolean
  error?: string
  onChange?: (value: string | null, metadata?: Record<string, any>) => void
  onSkipChange?: (skipValue: boolean) => void
}

const InsuranceMembershipIdQuestion: React.FC<
  InsuranceMembershipIdQuestionProps
> = ({
  question,
  control,
  errors,
  value,
  skipValue,
  error,
  onChange,
  onSkipChange,
}) => {
  const isRHFMode = !!control && !!errors
  const questionId =
    typeof question.id === 'string' ? parseInt(question.id, 10) : question.id

  if (isRHFMode && control && errors) {
    return (
      <InsuranceMembershipIdQuestionRHF
        question={question}
        control={control}
        errors={errors}
        questionId={questionId}
      />
    )
  }

  return (
    <InsuranceMembershipIdQuestionZustand
      question={question}
      value={value}
      skipValue={skipValue}
      error={error}
      onChange={onChange}
      onSkipChange={onSkipChange}
      questionId={questionId}
    />
  )
}

export default InsuranceMembershipIdQuestion
